import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20046e8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overview" }
const _hoisted_2 = { class: "overview_top" }
const _hoisted_3 = { class: "overview_top_data" }
const _hoisted_4 = { class: "data_content_title" }
const _hoisted_5 = { class: "content_title_text" }
const _hoisted_6 = { class: "data_content_num" }
const _hoisted_7 = {
  key: 0,
  class: "data_content_line"
}
const _hoisted_8 = { class: "overview_operate" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "refresh_text" }, "刷新", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "refresh_text" }, "导出", -1))
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "overview_buttom" }
const _hoisted_13 = { class: "mod_c region" }
const _hoisted_14 = { class: "mod_c_title" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "地域分布", -1))
const _hoisted_16 = { class: "region_distribute" }
const _hoisted_17 = ["id"]
const _hoisted_18 = { class: "overview_table" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "答题量排名", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "modulename_sub_more" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "modulename_sub_one" }, "排名"),
  /*#__PURE__*/_createElementVNode("li", { class: "modulename_sub_two" }, "省份"),
  /*#__PURE__*/_createElementVNode("li", null, "答题量")
], -1))
const _hoisted_21 = { class: "container_nub_one" }
const _hoisted_22 = { class: "container_nub_two" }
const _hoisted_23 = { class: "overview_buttom_right" }
const _hoisted_24 = { class: "mod_c equipment" }
const _hoisted_25 = { class: "mod_c_title" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "答题设备", -1))
const _hoisted_27 = ["id"]
const _hoisted_28 = { class: "mod_c system" }
const _hoisted_29 = { class: "mod_c_title" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "操作系统", -1))
const _hoisted_31 = ["id"]

import { onMounted, onUnmounted, ref } from 'vue';
import * as echarts from 'echarts';
import http from '@/api/questionnnaire';
import { useRoute } from 'vue-router';
import SvgIcon from '@/components/SvgIcon.vue';
import { getToken } from '@/plugins/cookie';
import { notification } from 'ant-design-vue';
// eslint-disable-next-line @typescript-eslint/no-var-requires
import { message, Table } from 'ant-design-vue';
import { UploadOutlined } from '@ant-design/icons-vue';
import { emptyDataSec } from '@/assets';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import https from '@/api/exportList';



export default /*#__PURE__*/_defineComponent({
  __name: 'Overview',
  setup(__props) {

const china = require('@/assets/json/china.json');
const aTable = Table;
const route = useRoute();
const studioId = route.params.studioId;
let questId: any = route.query.id;

// 折线图
const dataOverview: any = ref(`dataOverview${Date.now() + Math.random()}`);
let dataOverviewSet: any;
const getOption = () => {
  const setOption = {
    tooltip: {
      trigger: 'axis',
    },
    legend: {
      data: ['答题量', '浏览量'],
      x: 'left',
      left: '27%',
      itemGap: 122,
    },
    xAxis: {
      type: 'category',
      data: groupTimeList.value,
      axisPointer: {
        value: '2016-10-7',
        snap: true,
        lineStyle: {
          color: '#00CCB0',
          width: 1,
        },
        label: {
          show: true,
          formatter: function (params: any) {
            return params.value;
          },
          backgroundColor: '#00CCB0',
        },
        // handle: {
        //   show: true,
        //   color: '#00CCB0',
        // },
      },
    },
    yAxis: {
      type: 'value',
      splitLine: {
        lineStyle: {
          type: 'dashed',
        },
      },
    },
    grid: {
      // x: '6%',
      // width: '100%',
    },
    toolbox: {
      show: true,
      feature: {
        saveAsImage: {
          show: true,
          excludeComponents: ['toolbox'],
          pixelRatio: 2,
        },
      },
      right: '40',
      top: '-4',
    },
    series: [
      {
        name: '答题量',
        data: subSumList.value,
        type: 'line',
        smooth: true,
        itemStyle: {
          color: 'rgba(91, 143, 249, 1)',
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(91, 143, 249, 1)',
            },
            {
              offset: 1,
              color: 'rgba(91, 143, 249, 0)',
            },
          ]),
        },
      },
      {
        name: '浏览量',
        data: broSumList.value,
        type: 'line',
        smooth: true,
        itemStyle: {
          color: 'rgba(0, 204, 176, 1)',
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(0, 204, 176, 1)',
            },
            {
              offset: 1,
              color: 'rgba(0, 204, 176, 0)',
            },
          ]),
        },
      },
    ],
  };
  return setOption;
};
// 中国地图
const mapEchars: any = ref(`mapEchars${Date.now() + Math.random()}`);
let mapEcharsSet: any;
const mapOption = () => {
  const option = {
    tooltip: {
      show: true,
      formatter: function (params: { value: string; name: string }) {
        if (params.value) {
          return '&nbsp;&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;' + params.value + '个&nbsp;&nbsp;';
        } else {
          return '&nbsp;&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;0个&nbsp;&nbsp;';
        }
      },
      x: '550',
      y: '50',
      feature: {
        saveAsImage: {},
      },
    },
    visualMap: {
      min: addrList.value.length > 1 && addrList.value[addrList.value.length - 1].value,
      max: addrList.value.length > 0 && addrList.value[0].value,
      calculable: true,
      itemWidth: 21,
      itemHeight: 130,
      left: '0',
      bottom: '40',
      text: ['高', '低'],
      // calculable: true,
      color: '#999999',
      fontSize: 13,
      inRange: {
        color: ['#C7F3F5', '#00ccb0'],
      },
      outOfRange: {
        show: false,
      },
    },
    geo: {
      map: 'china',
      show: false,
      emphasis: {
        label: {
          show: false,
        },
      },
      itemStyle: {
        show: false,
      },
    },
    toolbox: {
      show: true,
      feature: {
        saveAsImage: {
          show: true,
          excludeComponents: ['toolbox'],
          pixelRatio: 2,
        },
      },
      top: '40',
      right: '16',
    },
    series: [
      {
        type: 'map',
        map: 'china',
        aspectScale: 0.75,
        showLegendSymbol: false,
        zoom: 1,
        roam: true,
        label: {
          formatter: function (para: { name: string }) {
            return '{name|' + para.name + '}';
          },
          rich: {
            cnNum: {
              fontSize: 11,
              color: '#E9E9E9',
              align: 'center',
              show: true,
            },
            name: {
              fontSize: 11,
              color: '#000',
              align: 'center',
              lineHeight: 60,
              show: true,
            },
          },
          color: '#000',
          show: false,
        },
        itemStyle: {
          areaColor: '#E9E9E9', //地图背景颜色
          borderColor: '#FFF',
          borderWidth: 1,
        },
        emphasis: {
          itemStyle: {
            areaColor: '#00ccb0',
            show: true,
          },
          label: {
            show: true,
            color: '#00ccb0',
          },
        },
        data: addrList.value,
      },
    ],
  };
  return option;
};
const mapColumns = ref([
  {
    title: '观看量排名',
    children: [
      {
        title: '排名',
        dataIndex: 'num',
        key: 'num',
        align: 'center',
        slots: {
          customRender: 'num',
        },
      },
      {
        title: '省份',
        dataIndex: 'name',
        key: 'name',
        align: 'center',
      },
      {
        title: '观看量',
        dataIndex: 'value',
        key: 'value',
        align: 'center',
      },
    ],
  },
]);

// 饼图
const pieEchars: any = ref(`pieEchars${Date.now() + Math.random()}`);
let pieEcharsSet: any;
const pieOption = () => {
  const option = {
    tooltip: {
      trigger: 'item',
    },
    color: ['#5B8FF9', '#00CCB0', '#65789B'],
    toolbox: {
      show: true,
      feature: {
        saveAsImage: {
          show: true,
          excludeComponents: ['toolbox'],
          pixelRatio: 2,
        },
      },
      top: '20',
      right: '20',
    },
    series: [
      {
        type: 'pie',
        label: {
          show: true,
          fontSize: '11',
          color: '#2C3542',
          formatter: '{b}\n{c}人',
        },
        data: deviceTypeList.value,
      },
      {
        type: 'pie',
        label: {
          show: true,
          position: 'inner',
          formatter: '{d}%',
          fontSize: '12',
          color: '#fff',
        },
        formatter: '{b}\n{c} 次/{d}%',
        data: deviceTypeList.value,
      },
    ],
  };
  return option;
};
const deviceTypeList: any = ref([]);

// 环形图
const ringEchars: any = ref(`ringEchars${Date.now() + Math.random()}`);
let ringEcharsSet: any;
const ringOption = () => {
  const option = {
    tooltip: {
      trigger: 'item',
    },
    color: ['#5B8FF9', '#00CCB0', '#65789B'],
    toolbox: {
      show: true,
      feature: {
        saveAsImage: {
          show: true,
          excludeComponents: ['toolbox'],
          pixelRatio: 2,
        },
      },
      top: '20',
      right: '20',
    },
    legend: {
      orient: 'left',
      left: 'left',
      top: '20',
      formatter: function (name: any) {
        const data = option.series[0].data;
        let total = 0;
        let tarValue: any;
        for (var i = 0, l = data.length; i < l; i++) {
          total += data[i].value;
          if (data[i].name == name) {
            tarValue = data[i].value;
          }
        }
        var p = ((tarValue / total) * 100).toFixed(0);
        return name + ' ' + ' ' + '' + p + '%';
      },
    },
    series: [
      {
        type: 'pie',
        radius: ['50%', '70%'],
        label: {
          show: false,
          position: 'center',
        },
        emphasis: {
          label: {
            show: true,
            formatter: '{b}\n\n{c}人',
            fontSize: '16',
            color: '#2C3542',
            align: 'center',
          },
        },
        data: deviceList.value,
      },
    ],
  };
  return option;
};
const deviceList: any = ref([]);

const questCurveList: any = ref([]);
const broSumList: any = ref([]);
const subSumList: any = ref([]);
const groupTimeList: any = ref([]);
const questInfoList: any = ref([
  {
    title: '浏览量',
    icon: 'views',
    number: '0',
  },
  {
    title: '答题量',
    icon: 'answers',
    number: '0',
  },
  {
    title: '答题率',
    icon: 'answerRate',
    number: '0%',
  },
  {
    title: '平均答题时间',
    icon: 'answerTime',
    number: '0时0分0秒',
  },
]);
const addrList: any = ref([]);

// 获取接口数据
const getQuestOverview = useDebounce(() => {
  const data = {
    studio_id: studioId,
    quest_id: questId,
    export: 0,
  };
  http
    .questOverview({ params: data })
    .then((res) => {
      const resData = res.data.data;
      const quest_info = resData.quest_info;
      questInfoList.value[0].number = quest_info.browse_count;
      questInfoList.value[1].number = quest_info.submit_count;
      questInfoList.value[2].number = quest_info.answer_rate;
      questInfoList.value[3].number = `${quest_info.answer_average_time.hour}时${quest_info.answer_average_time.minute}分${quest_info.answer_average_time.second}秒`;
      // 折线图
      questCurveList.value = [...resData.quest_curve];
      broSumList.value = [];
      subSumList.value = [];
      groupTimeList.value = [];
      resData.quest_curve.map((res: any) => {
        broSumList.value.push(res.bro_sum);
        subSumList.value.push(res.sub_sum);
        groupTimeList.value.push(res.group_time);
      });
      // 中国地图
      addrList.value = [];
      addrList.value = [...resData.addr_list];
      echarts.registerMap('china', china);
      // 饼图
      deviceTypeList.value = [];
      deviceTypeList.value = [...resData.device_type_list];
      // 环形图
      deviceList.value = [];
      deviceList.value = [...resData.device_list];

      const newPromise = new Promise((resolve) => {
        resolve(true);
      });
      newPromise.then(() => {
        // 折线图
        if (questCurveList.value.length > 0) {
          const dataOverviewHtml = document.getElementById(dataOverview.value) as HTMLElement;
          dataOverviewSet = echarts.init(dataOverviewHtml);
          getOption() && dataOverviewSet.setOption(getOption());
        }
        // 中国地图
        const mapEcharsHtml = document.getElementById(mapEchars.value) as HTMLElement;
        mapEcharsSet = echarts.init(mapEcharsHtml);
        mapOption() && mapEcharsSet.setOption(mapOption());
        // 饼图
        const pieEcharsHtml = document.getElementById(pieEchars.value) as HTMLElement;
        pieEcharsSet = echarts.init(pieEcharsHtml);
        pieOption() && pieEcharsSet.setOption(pieOption());
        // 环形图
        const ringEcharsHtml = document.getElementById(ringEchars.value) as HTMLElement;
        ringEcharsSet = echarts.init(ringEcharsHtml);
        ringOption() && ringEcharsSet.setOption(ringOption());
      });
    })
    .catch((err) => {
      // message.error(err.data.error);
    });
});
questId ? getQuestOverview() : '';

// 导出
const token = getToken();
const corn = ref(1);
const messageTip = ref();
const toExport = useDebounce((status: number) => {
  const data = {
    studio_id: studioId,
    export: status,
    is_cron_download: corn.value,
    quest_id: questId,
  };
  https
    .quest_overview({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};

onMounted(() => {
  window.onresize = () => {
    dataOverviewSet ? dataOverviewSet.resize() : '';
    mapEcharsSet ? mapEcharsSet.resize() : '';
    pieEcharsSet ? pieEcharsSet.resize() : '';
    ringEcharsSet ? ringEcharsSet.resize() : '';
  };
});

onUnmounted(() => {
  window.onresize = null;
});

// watch(route, (count) => {
//   questId = count.query.id;
//   questId ? getQuestOverview() : '';
// });

return (_ctx: any,_cache: any) => {
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questInfoList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "data_content",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(SvgIcon, {
                "icon-class": item.icon
              }, null, 8, ["icon-class"]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1)
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.number), 1),
            (index !== 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "overview_operate_refresh",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(getQuestOverview) && _unref(getQuestOverview)(...args)))
        }, [
          _createVNode(SvgIcon, { "icon-class": "refresh" }),
          _hoisted_9
        ]),
        _createElementVNode("div", {
          class: "overview_operate_refresh",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(toExport)(1)))
        }, [
          _createVNode(SvgIcon, { "icon-class": "export" }),
          _hoisted_10
        ])
      ]),
      (questCurveList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "lineEchars",
            id: dataOverview.value
          }, null, 8, _hoisted_11))
        : (_openBlock(), _createBlock(_component_a_empty, {
            key: 1,
            class: "empty_wrap",
            image: _unref(emptyDataSec),
            description: "页面暂无数据信息~"
          }, null, 8, ["image"]))
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_a_button, {
            type: "link",
            class: "mod_switch_btn mod_home_section_btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(toExport)(2)))
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(UploadOutlined), { class: "mod_btn_icon" })
            ]),
            default: _withCtx(() => [
              _createTextVNode(" 导出 ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "map_echars",
            id: mapEchars.value
          }, null, 8, _hoisted_17),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _hoisted_20,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addrList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("ul", {
                key: index,
                class: "container_sub_nub"
              }, [
                _createElementVNode("li", _hoisted_21, _toDisplayString(index + 1), 1),
                _createElementVNode("li", _hoisted_22, _toDisplayString(item.name), 1),
                _createElementVNode("li", null, _toDisplayString(item.value), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_a_button, {
              type: "link",
              class: "mod_switch_btn mod_home_section_btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(toExport)(3)))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(UploadOutlined), { class: "mod_btn_icon" })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" 导出 ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            class: "equipment_eachars",
            id: pieEchars.value
          }, null, 8, _hoisted_27)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createVNode(_component_a_button, {
              type: "link",
              class: "mod_switch_btn mod_home_section_btn",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(toExport)(4)))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(UploadOutlined), { class: "mod_btn_icon" })
              ]),
              default: _withCtx(() => [
                _createTextVNode(" 导出 ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            class: "system_echars",
            id: ringEchars.value
          }, null, 8, _hoisted_31)
        ])
      ])
    ])
  ]))
}
}

})